<template>
    <div>
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <div v-show="innerShouldShow">
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <div class="d-flex">
                        <validation-provider
                            v-slot="{ errors }"
                            v-bind="providerProps"
                            ref="vp"
                            :name="label || 'This'"
                            :rules="rules"
                            mode="eager"
                            tag="div"
                            class="flex-grow-1"
                            :vid="'validate-' + fieldAssignmentId"
                        >
                            <v-text-field
                                v-bind="[vProps, $attrs]"
                                v-model="innerValue"
                                :error-messages="errors"
                                :prepend-inner-icon="
                                    vProps.prepend_icon
                                        ? vProps.prepend_icon
                                        : null
                                "
                                @keyup="checkMoney()"
                                @blur="checkMoney(true)"
                            >
                                <template #label>
                                    <span v-if="innerLabel" v-html="innerLabel"></span>
                                </template>
                                <template v-if="vProps.show_netrate" #message>
                                    <span>{{ vProps.hint }}</span
                                    ><span v-if="innerValue"
                                        >${{ innerValue }}</span
                                    >
                                </template>
                            </v-text-field>
                        </validation-provider>
                    </div>
                </div>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';

export default {
    name: 'TypeMoney',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    props: {
        showIcon: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            changeTimeout: null
        };
    },
    mounted() {
        if( !this.innerValue ) {
          this.innerValue = this.default_value || 0;
        }
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true,
                persistentPlaceholder: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                required:
                    !!this.validation_settings.required &&
                    !!this.innerShouldShow
            } : {};
        }
        /* computedIcon() {
            return vProps.prepend_icon // ? `${vProps.prepend_icon}` : false;
        }, */
    },
    methods: {
        checkMoney(roundCents = false) {
            if (this.changeTimeout) clearTimeout(this.changeTimeout);

            let t = 200;
            if ((this.innerValue + '').match(/[.]$/g)) t = 2000;

            this.changeTimeout = setTimeout(() => {
                const text = (this.innerValue + '').replace(/[^0-9.-]/g, '');
                const hasCents = text.match(/[.]\d\d+/g);

                let total = parseFloat(text || 0);
                if (hasCents || roundCents) total = total.toFixed(2); // removed decimal. Make sure it's always at 2 to end

                let neg = false;
                if (total < 0) {
                    neg = true;
                    total = Math.abs(total);
                }

                total = parseFloat(total, 10);
                if (hasCents || roundCents) total = total.toFixed(2);

                this.innerValue =
                    (neg ? '-' : '') +
                    (total + '')
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                        .toString();
                this.$emit('change', this.innerValue);
            }, t);
        }
    }
};
</script>
